import React from 'react'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { Box } from '@material-ui/core'
import { ControlledTextField } from '../form/ControlledTextField'
import { FormGroup } from '../form/FormGroup'
import { validators } from '../../validation/validators'
import { WizardStep, WizardStepProps } from '../form/WizardStep'
import { PurchasedEnergyType } from '../../generated/graphql'

type InternalPricingModelEnergyPriceIncreaseRateFormValues = {
  energyType: PurchasedEnergyType
  priceIncreaseRate: string
}

export type PricingModelEnergyPriceIncreaseRateFormValues = {
  priceIncreaseRates: InternalPricingModelEnergyPriceIncreaseRateFormValues[]
}

export type PricingModelEnergyPriceStepProps =
  WizardStepProps<PricingModelEnergyPriceIncreaseRateFormValues> & {
    onSubmit: (values: PricingModelEnergyPriceIncreaseRateFormValues) => void
  }

export function PricingModelEnergyPriceIncreaseRateStep(
  props: PricingModelEnergyPriceStepProps,
): React.ReactElement {
  const { defaultValues, onSubmit } = props
  const { t } = useTranslation()

  const { control, handleSubmit, errors } =
    useForm<PricingModelEnergyPriceIncreaseRateFormValues>({
      defaultValues,
    })

  const title = t('pricingModels.energyPriceIncreaseRate')

  return (
    <WizardStep
      {...props}
      title={title}
      onSubmit={handleSubmit(onSubmit)}
      dataCy="energy-price-increase-step"
    >
      {(defaultValues?.priceIncreaseRates ?? []).map(
        (priceIncreaseRate, index) => (
          <>
            <Box display="none">
              <ControlledTextField
                control={control}
                name={`priceIncreaseRates[${index}].energyType`}
                rules={validators.required}
                error={errors.priceIncreaseRates?.[index]?.energyType}
                defaultValue={priceIncreaseRate.energyType}
              />
            </Box>
            <FormGroup key={priceIncreaseRate.energyType}>
              <ControlledTextField
                control={control}
                name={`priceIncreaseRates[${index}].priceIncreaseRate`}
                rules={validators.required}
                error={errors.priceIncreaseRates?.[index]?.priceIncreaseRate}
                label={t('pricingModels.energyPriceIncreaseRateByEnergyType', {
                  energyType: t(
                    `purchasedEnergyType.${priceIncreaseRate.energyType}`,
                  ),
                })}
                defaultValue={priceIncreaseRate.priceIncreaseRate}
              />
            </FormGroup>
          </>
        ),
      )}
    </WizardStep>
  )
}
